<div  style="width: 100%; text-align: center;" >
    <div


class="contentContainer" style="margin-top: 100px;">


    <DIV class="appLabel" >
         Helpline : +91-94265 93253</DIV>
    <DIV class="appLabel" >Whatsapp : +91-94265 93254</DIV>
    <DIV class="appLabel" >Email : hello&#64;aayaan.org</DIV>
    <DIV class="appLabel" >Website : www.aayaan.org</DIV>

</div>
</div>